import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import Checkbox from '../Checkbox/index.js';
import SwitchIcon from '../SwitchIcon/index.js';

function Switch(props) {
  return /*#__PURE__*/React.createElement(Checkbox, _extends({}, props, {
    checkmark: SwitchIcon
  }));
}

export { Switch as default };
//# sourceMappingURL=index.js.map
